<template>
    <div v-if="validationEnabled">
        <p id="invalid-address-message" v-if="!addressIsValid" class="paragraph-default invalid-state">
            {{ props.invalidAddressMessage }}
        </p>
        <p id="suggested-address-message" v-else-if="addressIsValid && addressIsDifferent" class="paragraph-default">
            <a class="text-link" @click="openSuggestedAddressModal">
                {{ props.useSuggestedMessage }}
            </a>
        </p>
    </div>
</template>
<script lang="ts" setup>
    import { computed, toRefs } from "vue";
    import { useAddressValidation } from "@/helpers/composables/useAddressValidation";
    import { useDialog } from "primevue/usedialog";
    import SuggestedAddressModal from "@/components/SuggestedAddressModal.vue";

    let props = defineProps({
        street1: { type: String, default: "" }, 
        street2: { type: String, default: "" },
        city: { type: String, default: "" }, 
        state: { type: String, default: "" },
        postal_code: { type: String, default: "" },
        country: { type: String, default: "" },

        invalidAddressMessage: {
            type: String,
            default: "The address you entered may be invalid."
        },
        useSuggestedMessage: {
            type: String,
            default: "Use Suggested Address"
        }
    })

    const dialog = useDialog();

    const {
        street1, street2, city, state, postal_code, country
    } = toRefs(props);

    const currentAddress = computed(()=>{
        return {
            street1: street1, 
            street2: street2, 
            city: city, 
            state: state, 
            postal_code: postal_code, 
            country: country
        }
    })
    
    const enableAddressValidation = computed(()=>{
        return ['US','USA'].includes(currentAddress.value.country.value);
    })

    let { isValid:addressIsValid, isDifferent:addressIsDifferent, validationEnabled, validAddress } =
        useAddressValidation(
            {
                street1: currentAddress.value.street1,
                street2: currentAddress.value.street2,
                city: currentAddress.value.city,
                state: currentAddress.value.state,
                postal_code: currentAddress.value.postal_code,
                country: currentAddress.value.country
            },
            enableAddressValidation
        );
    
    let suggestedAddress = computed(() => {
        return {
            ...currentAddress.value,
            street1: validAddress.value.street1 ? validAddress.value.street1 : currentAddress.value.street1.value,
            street2: validAddress.value.street2 ? validAddress.value.street2 : currentAddress.value.street2.value,
            city: validAddress.value.city ? validAddress.value.city : currentAddress.value.city.value,
            state: validAddress.value.state ? validAddress.value.state : currentAddress.value.state.value,
            postal_code: validAddress.value.postal_code ? validAddress.value.postal_code : currentAddress.value.postal_code.value,
            country: validAddress.value.country ? validAddress.value.country : currentAddress.value.country.value
        };
    });

    let openSuggestedAddressModal = () => {
        dialog.open(SuggestedAddressModal, {
            props: {
                showHeader: false,
            },
            data: {
                oldAddress: currentAddress,
                newAddress: suggestedAddress.value,
            },
            onClose: (props) => {
                if(props?.data?.useSuggestedAddress){
                    useSuggestedAddress();
                }
            }
        })
    };

    const emit = defineEmits(["useSuggestedAddress"]);
    let useSuggestedAddress = () => {
        emit("useSuggestedAddress", suggestedAddress.value);
    };
</script>
